var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevronUp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7 13.3L12.7 7.3C12.3 6.9 11.7 6.9 11.3 7.3L5.3 13.3C4.9 13.7 4.9 14.3 5.3 14.7C5.7 15.1 6.3 15.1 6.7 14.7L12 9.4L17.3 14.7C17.5 14.9 17.8 15 18 15C18.2 15 18.5 14.9 18.7 14.7C19.1 14.3 19.1 13.7 18.7 13.3Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevronUp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconChevronUp.8398dd2ada0726468f71ca3d9d04d304.svg";